<template>
  <multiselect
    class="titan-select custom-field"
    v-model="internalValue"
    :options="values"
    :label="valueLabel"
    :disabled="disabled"
    :placeholder="placeholder"
    :required="required"
    :preselectFirst="preselectFirst"
    :trackBy="trackBy"
    :multiple="multiple"
    tagPlaceholder=""
    selectLabel=""
    selectedLabel=""
    deselectLabel=""
    v-on:select="selectData($event)"
    v-on:remove="removeSelectedData($event)"
  >
    <template slot="singleLabel" slot-scope="props">
      <span v-html="customTemplate(props.option, 'singleLabel')"></span>
    </template>
    <template slot="option" slot-scope="props">
      <span v-html="customTemplate(props.option, 'option')"></span>
    </template>
    <template slot="noResult">
      {{ t('No results found') }}
    </template>
  </multiselect>
</template>
<script>
import { abstractField } from 'vue-form-generator'
import Multiselect from 'vue-multiselect'

export default {
        mixins: [abstractField],
        components: {Multiselect},
        props: {
          trackByOptions: {
            type: Array,
            default() {
              return ['id', 'value']
            }
          }
        },
        mounted() {
            this.initData()
        },
        watch: {
            value(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.initData()
                }
            }
        },
        computed: {
            multiple() {
                return this.schema.multiple === undefined ? false : this.schema.multiple
            },
            trackBy() {
                let trackByAttempts = this.schema.trackBy === undefined ? this.trackByOptions : [this.schema.trackBy]
                let trackBy = null
                if (this.values.length > 0) {
                  trackBy = trackByAttempts.find(item => this.values[0].hasOwnProperty(item))
                }
                if (!trackBy) {
                  console.warn('Couldn\'t identify property to track select values. Expect problems.')
                  trackBy = 'id';
                }
                return trackBy;
            },
            preselectFirst() {
                return this.schema.preselectFirst === undefined ? false : this.schema.preselectFirst
            },
            valueLabel() {
                return this.schema.valueLabel === undefined ? 'name' : this.schema.valueLabel
            },
            required() {
                return this.schema.required === undefined ? false : this.schema.required
            },
            values() {
                if (this.schema.codeBook !== undefined && this.schema.codeBook !== null) {
                    return this.$store.getters['codeBook/get'](this.schema.codeBook)
                }
                return this.schema.values === undefined ? [] : this.schema.values
            },
            placeholder() {
                return this.schema.placeholder === undefined ? '' : this.schema.placeholder
            },
            isConstant() {
                return this.schema.constant === undefined ? false : this.schema.constant
            },
        },
        methods: {
            customTemplate(item, type) {
                return this.schema[type] === undefined
                    ? item[this.valueLabel]
                    : this.schema[type](item)
            },
            selectData(item) {
                if (this.multiple === false) {
                    this.value = this.isConstant === true && item !== null ? item[this.trackBy] : item
                    if (_.isFunction(this.schema.onSelect) === true) {
                        this.schema.onSelect(this.value)
                    }
                } else {
                    this.value.push(item)
                }
            },
            removeSelectedData(item) {
                if (this.multiple === false) {
                    this.selectData(null)
                } else {
                    const foundIndex = this.value.findIndex((valueItem) => {
                        return item[this.trackBy] === valueItem[this.trackBy]
                    })
                    if (foundIndex > -1) {
                        this.value.splice(foundIndex, 1);
                    }
                }
            },
            initData() {
                if (this.isConstant === true) {
                  this.internalValue = this.values.find(item => {
                      return item[this.trackBy] === this.value
                    })
                } else {
                    this.internalValue = this.multiple ? [...this.value] : this.value
                }
            },
        },
        data() {
            return {
                internalValue: null,
            }
        }
    }
</script>
<style lang="scss">
  @import 'vue-multiselect/dist/vue-multiselect.min.css';

  .titan-select {
    min-height: 38px;

    &.multiselect--disabled {
      .multiselect__select {
        display: none;
      }
    }

    .multiselect__content-wrapper,
    .multiselect__tags {
      border-color: #ced4da;
    }

    .multiselect__tags {
      min-height: 38px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/core/Form/Fields/Select.vue